"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var querystring_1 = require("querystring");
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var uuid_1 = require("uuid");
var Button_1 = __importDefault(require("../../components/Button/Button"));
var PauseIcon_1 = __importDefault(require("../../components/Icon/PauseIcon"));
var StopIcon_1 = __importDefault(require("../../components/Icon/StopIcon"));
var Link_1 = __importDefault(require("../../components/Link/Link"));
var Tooltip_1 = __importDefault(require("../../components/Tooltip/Tooltip"));
var constants_1 = require("../../constants");
var hooks_1 = require("../../hooks");
var ConfigProvider_1 = require("../../providers/ConfigProvider");
var either_1 = require("../../utils/either");
var VyhledavaniTable_1 = __importDefault(require("./components/VyhledavaniTable"));
var ButtonWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 2em;\n  display: flex;\n  justify-content: center;\n"], ["\n  padding: 2em;\n  display: flex;\n  justify-content: center;\n"])));
var StyledHeader = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 50px;\n  background: #e5ebf0;\n  padding: 0 30px;\n  display: flex;\n  align-items: center;\n\n  @media only screen and (max-width: 500px) {\n    flex-direction: column;\n    align-items: flex-start;\n    height: 70px;\n  }\n"], ["\n  height: 50px;\n  background: #e5ebf0;\n  padding: 0 30px;\n  display: flex;\n  align-items: center;\n\n  @media only screen and (max-width: 500px) {\n    flex-direction: column;\n    align-items: flex-start;\n    height: 70px;\n  }\n"])));
var CheckboxWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-right: 30px;\n  @media only screen and (max-width: 500px) {\n    margin-top: 10px !important;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  margin-right: 30px;\n  @media only screen and (max-width: 500px) {\n    margin-top: 10px !important;\n  }\n"])));
var StyledCheckbox = styled_components_1.default(antd_1.Checkbox)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  .ant-checkbox-inner {\n    width: 20px;\n    height: 20px;\n    border-radius: 3px;\n    border: 2px solid #2362a2;\n    outline: none;\n  }\n  .ant-radio-input:focus + .ant-radio-inner {\n    box-shadow: none;\n    outline: none;\n  }\n  &.ant-checkbox-wrapper {\n    align-items: flex-end;\n    & > *:last-child {\n      font-size: 12px;\n      font-weight: 500;\n      line-height: 100%;\n      padding-left: 15px;\n      color: #3b3b3b;\n      text-transform: uppercase;\n    }\n  }\n"], ["\n  .ant-checkbox-inner {\n    width: 20px;\n    height: 20px;\n    border-radius: 3px;\n    border: 2px solid #2362a2;\n    outline: none;\n  }\n  .ant-radio-input:focus + .ant-radio-inner {\n    box-shadow: none;\n    outline: none;\n  }\n  &.ant-checkbox-wrapper {\n    align-items: flex-end;\n    & > *:last-child {\n      font-size: 12px;\n      font-weight: 500;\n      line-height: 100%;\n      padding-left: 15px;\n      color: #3b3b3b;\n      text-transform: uppercase;\n    }\n  }\n"])));
var Text = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  @media only screen and (max-width: 881px) {\n    display: none;\n  }\n"], ["\n  @media only screen and (max-width: 881px) {\n    display: none;\n  }\n"])));
var ShortText = styled_components_1.default.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  @media only screen and (min-width: 882px) {\n    display: none;\n  }\n"], ["\n  @media only screen and (min-width: 882px) {\n    display: none;\n  }\n"])));
var StyledDiv = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 3fr 0.5fr;\n  grid-gap: 5px;\n  width: 160px;\n  & > *:last-child {\n    justify-self: flex-end;\n    & > * {\n      display: block;\n      margin-top: 3px;\n    }\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 3fr 0.5fr;\n  grid-gap: 5px;\n  width: 160px;\n  & > *:last-child {\n    justify-self: flex-end;\n    & > * {\n      display: block;\n      margin-top: 3px;\n    }\n  }\n"])));
var STr = styled_components_1.default.tr(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  border-bottom: 5px solid transparent;\n"], ["\n  border-bottom: 5px solid transparent;\n"])));
var STd = styled_components_1.default.td(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  vertical-align: top !important;\n"], ["\n  vertical-align: top !important;\n"])));
var OborCellDiv = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  height: ", ";\n  max-width: 160px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n"], ["\n  height: ", ";\n  max-width: 160px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n"])), function (props) { return (props.height === '0px' ? '50px' : props.height); });
var CellDiv = styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  height: 50px;\n  max-width: 170px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n"], ["\n  height: 50px;\n  max-width: 170px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n"])));
var SpecCellDiv = styled_components_1.default(CellDiv)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  max-width: 290px;\n"], ["\n  max-width: 290px;\n"])));
var DruhDiv = styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  width: 20px;\n  height: 20px;\n  background-color: #2362a2;\n  border-radius: 3px;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 500;\n  text-align: center;\n"], ["\n  width: 20px;\n  height: 20px;\n  background-color: #2362a2;\n  border-radius: 3px;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 500;\n  text-align: center;\n"])));
var getNameValue = function (obj) {
    var name = [obj === null || obj === void 0 ? void 0 : obj.prijmeni, obj === null || obj === void 0 ? void 0 : obj.jmeno, obj === null || obj === void 0 ? void 0 : obj.titul].filter(function (e) { return e; }).join(' ');
    if (obj === null || obj === void 0 ? void 0 : obj.titulZa) {
        return name + ", " + (obj === null || obj === void 0 ? void 0 : obj.titulZa);
    }
    return name;
};
var vysledkyTooltip = function (vysledkyData, maxDelka) {
    var zobrazit = vysledkyData.join('; ');
    var zkraceno = false;
    if (zobrazit.length > maxDelka) {
        zobrazit = zobrazit.slice(0, maxDelka - 3);
        var lastSpace = zobrazit.lastIndexOf(' ');
        var lastComma = zobrazit.lastIndexOf(',');
        var lastSeparator = lastSpace > lastComma ? lastSpace : lastComma;
        if (lastSeparator > 0)
            zobrazit = zobrazit.slice(0, lastSeparator);
        zkraceno = true;
    }
    var forTooltip = (react_1.default.createElement("div", { key: uuid_1.v4() }, vysledkyData.map(function (v) { return (react_1.default.createElement("div", { key: uuid_1.v4() }, v)); })));
    return (react_1.default.createElement(Tooltip_1.default, { content: forTooltip },
        react_1.default.createElement("span", null,
            zobrazit,
            zkraceno && ' ...')));
};
var getTabulkaObory = function (item) {
    return (react_1.default.createElement("table", null,
        react_1.default.createElement("tbody", null, item.specializaceStrom.map(function (obor) {
            var _a;
            return (react_1.default.createElement(STr, { style: { marginBottom: 10 }, key: uuid_1.v4() },
                react_1.default.createElement(STd, null,
                    react_1.default.createElement(OborCellDiv, { height: String(((_a = obor.podrizene) === null || _a === void 0 ? void 0 : _a.length) * 50) + "px" }, vysledkyTooltip([obor.nazev], 60)))));
        }))));
};
var getTabulkaOdvetvi = function (item) {
    return (react_1.default.createElement("table", null,
        react_1.default.createElement("tbody", null, item.specializaceStrom.map(function (obor) {
            if (obor.podrizene.length === 0)
                return (react_1.default.createElement(STr, { key: uuid_1.v4() },
                    react_1.default.createElement(STd, null,
                        react_1.default.createElement(CellDiv, null, "-"))));
            return obor.podrizene.map(function (odvetvi) {
                return (react_1.default.createElement(STr, { key: uuid_1.v4() },
                    react_1.default.createElement(STd, null,
                        react_1.default.createElement(CellDiv, null, vysledkyTooltip([odvetvi.nazev], 60)))));
            });
        }))));
};
var getTabulkaSpecializace = function (item) {
    return (react_1.default.createElement("table", null,
        react_1.default.createElement("tbody", null, item.specializaceStrom.map(function (obor) {
            var _a;
            if (((_a = obor === null || obor === void 0 ? void 0 : obor.podrizene) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                return (react_1.default.createElement(STr, { key: uuid_1.v4() },
                    react_1.default.createElement(STd, null,
                        react_1.default.createElement(SpecCellDiv, null, "-"))));
            }
            return obor.podrizene.map(function (odvetvi) {
                var _a;
                if (((_a = odvetvi === null || odvetvi === void 0 ? void 0 : odvetvi.podrizene) === null || _a === void 0 ? void 0 : _a.length) === 0)
                    return (react_1.default.createElement(STr, { key: uuid_1.v4() },
                        react_1.default.createElement(STd, null,
                            react_1.default.createElement(SpecCellDiv, null, "-"))));
                return (react_1.default.createElement(STr, { key: uuid_1.v4() },
                    react_1.default.createElement(STd, null,
                        react_1.default.createElement(SpecCellDiv, null, vysledkyTooltip(odvetvi.podrizene.map(function (sp) { return sp.nazev; }), 60)))));
            });
        }))));
};
var getDruhOsoby = function (item) {
    if (item.druhOsoby === constants_1.ZnalciDruhOsoby.znaleckaKancelar)
        return (react_1.default.createElement(Tooltip_1.default, { content: "Znaleck\u00E1 kancel\u00E1\u0159" },
            react_1.default.createElement(DruhDiv, null,
                react_1.default.createElement("span", null, "ZK"))));
    if (item.druhOsoby === constants_1.ZnalciDruhOsoby.znaleckyUstav)
        return (react_1.default.createElement(Tooltip_1.default, { content: "Znaleck\u00FD \u00FAstav" },
            react_1.default.createElement(DruhDiv, null,
                react_1.default.createElement("span", null, "Z\u00DA"))));
    return (react_1.default.createElement(Tooltip_1.default, { content: "Znalec" },
        react_1.default.createElement(DruhDiv, null,
            react_1.default.createElement("span", null, "Zn"))));
};
var VysledkyVyhledavani = function (_a) {
    var query = _a.query, setQuery = _a.setQuery, encodedQuery = _a.encodedQuery;
    var _b = ConfigProvider_1.useConfig(), apiUrl = _b.apiUrl, typ = _b.typ;
    var _c = react_1.useState(), data = _c[0], setData = _c[1];
    var isLoading = hooks_1.useBoolean(true);
    var isLoadingMore = hooks_1.useBoolean(false);
    var _d = react_1.useState(1), page = _d[0], setPage = _d[1];
    var postSearch = hooks_1.usePostJSON(apiUrl + "/Search");
    var _e = react_1.useState(), dataError = _e[0], setDataError = _e[1];
    var sortByLens = ramda_1.lensPath(['razeni', 'hodnota']);
    var sortTypeLens = ramda_1.lensPath(['razeni', 'smer']);
    var stranekCelkem = ramda_1.path(['strankovani', 'stranekCelkem'], data);
    var vcetnePozastavenychLens = ramda_1.lensPath(['filter', 'vcetnePozastavenych']);
    var vcetneZaniklychLens = ramda_1.lensPath(['filter', 'vcetneZaniklych']);
    var pocetNaStrankuLens = ramda_1.lensPath(['strankovani', 'pocetNaStranku']);
    var isSoudniZnalec = function (item) { return item.druhOsoby === constants_1.ZnalciDruhOsoby.znalec && typ === 'znalec'; };
    var isTlumocnik = function (item) { return item && typ === 'tlumocnik'; };
    var getName = function (item) {
        if (isTlumocnik(item)) {
            return getNameValue(item);
        }
        if (isSoudniZnalec(item)) {
            return getNameValue(item.soudniZnalec);
        }
        if (item.nazevUtvaru) {
            return item.nazev + " - " + item.nazevUtvaru;
        }
        return item.nazev;
    };
    react_1.useEffect(function () {
        var loadData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isLoading.setTrue();
                        setDataError(undefined);
                        return [4 /*yield*/, postSearch(query)];
                    case 1:
                        response = _a.sent();
                        if (either_1.isRight(response)) {
                            setPage(1);
                            setData(response.value);
                        }
                        else
                            setDataError(response.value.message);
                        isLoading.setFalse();
                        return [2 /*return*/];
                }
            });
        }); };
        loadData();
    }, [query]);
    var handleLoadMore = function () { return __awaiter(void 0, void 0, void 0, function () {
        var strankaLens, zaznamyLens, nextPage, response, noveZaznamy_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isLoadingMore.setTrue();
                    strankaLens = ramda_1.lensPath(['strankovani', 'stranka']);
                    zaznamyLens = ramda_1.lensPath(['zaznamy']);
                    nextPage = page + 1;
                    return [4 /*yield*/, postSearch(ramda_1.set(strankaLens, nextPage, query))];
                case 1:
                    response = _a.sent();
                    if (either_1.isRight(response)) {
                        noveZaznamy_1 = ramda_1.view(zaznamyLens, response.value) || [];
                        setData(ramda_1.over(zaznamyLens, function (z) { return ramda_1.concat(z, noveZaznamy_1); }, data));
                        setPage(nextPage);
                        setQuery(ramda_1.over(pocetNaStrankuLens, function (p) { return p + 50; }, query));
                    }
                    isLoadingMore.setFalse();
                    return [2 /*return*/];
            }
        });
    }); };
    var toggleVcetnePozastavenych = function () {
        setQuery(ramda_1.over(vcetnePozastavenychLens, ramda_1.not, query));
    };
    var toggleVcetneZaniklych = function () {
        setQuery(ramda_1.over(vcetneZaniklychLens, ramda_1.not, query));
    };
    var handleSort = function (_a) {
        var dataIndex = _a.dataIndex, type = _a.type;
        var updatedQuery = ramda_1.pipe(ramda_1.set(sortByLens, dataIndex), ramda_1.set(sortTypeLens, type === 'DESC' ? 1 : 0))(query);
        setQuery(updatedQuery);
    };
    var aktivniInfo = function (item) {
        var pozastaveniInfo = item.aktivniPozastaveni && react_1.default.createElement(PauseIcon_1.default, { toolTip: "Osoba s pozastavenou \u010Dinnost\u00ED" });
        var zanikInfo = item.aktivniZanik && react_1.default.createElement(StopIcon_1.default, { toolTip: "Osoba se z\u00E1nikem opr\u00E1vn\u011Bn\u00ED" });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            pozastaveniInfo,
            zanikInfo));
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(StyledHeader, null,
            react_1.default.createElement(CheckboxWrapper, null,
                react_1.default.createElement(StyledCheckbox, { onChange: toggleVcetnePozastavenych, checked: ramda_1.view(vcetnePozastavenychLens, query), type: "checkbox", id: "CheckPozastavene" },
                    react_1.default.createElement(Text, null, "Zobrazit i osoby s pozastavenou \u010Dinnost\u00ED"),
                    react_1.default.createElement(ShortText, null, "Pozastaven\u00E1 \u010Dinnost"))),
            react_1.default.createElement(CheckboxWrapper, null,
                react_1.default.createElement(StyledCheckbox, { onChange: toggleVcetneZaniklych, checked: ramda_1.view(vcetneZaniklychLens, query), type: "checkbox", id: "CheckZanikle" },
                    react_1.default.createElement(Text, null, "Zobrazit i osoby se z\u00E1nikem opr\u00E1vn\u011Bn\u00ED vykon\u00E1vat \u010Dinnost"),
                    react_1.default.createElement(ShortText, null, "Zanikl\u00E1 \u010Dinnost")))),
        react_1.default.createElement(VyhledavaniTable_1.default, { setSort: handleSort, sort: {
                dataIndex: ramda_1.view(sortByLens, query),
                type: ramda_1.view(sortTypeLens, query) ? 'DESC' : 'ASC',
            }, typOsoby: typ, loading: isLoading.value, znalci: data, searchRequest: query, enableGenerate: true, dataError: dataError, columns: __spreadArrays([
                {
                    title: typ === 'tlumocnik' ? 'Jméno' : 'Jméno/název',
                    dataIndex: 'jmeno',
                    render: function (_, item) { return (react_1.default.createElement(StyledDiv, null,
                        react_1.default.createElement(Link_1.default, { to: "/" + typ + "/detail/" + item.id + "?" + querystring_1.stringify(encodedQuery) }, getName(item)),
                        react_1.default.createElement("div", null, aktivniInfo(item)))); },
                }
            ], (typ === 'znalec'
                ? [
                    {
                        title: 'Typ',
                        dataIndex: 'druhOsobyNazev',
                        render: function (_, item) { return getDruhOsoby(item); },
                    },
                    {
                        title: 'Obor',
                        dataIndex: 'specializace',
                        render: function (_, item) { return getTabulkaObory(item); },
                    },
                    {
                        title: 'Odvětví',
                        dataIndex: 'odvetvi',
                        render: function (_, item) { return getTabulkaOdvetvi(item); },
                    },
                    {
                        title: 'Specializace',
                        dataIndex: 'specializacePodrizene',
                        render: function (_, item) { return getTabulkaSpecializace(item); },
                    },
                ]
                : []), (typ === 'tlumocnik'
                ? [
                    {
                        title: 'Typ',
                        dataIndex: 'druhOsobyNazev',
                    },
                    {
                        title: 'Jazyk',
                        dataIndex: 'jazykySpecializace',
                        render: function (jazyky) { return vysledkyTooltip(jazyky.map(function (jazyk) { return jazyk.jazyk; }) || [], 60); },
                    },
                    {
                        title: 'Specializace',
                        dataIndex: 'specializace',
                        render: function (specializace) { return vysledkyTooltip(specializace || [], 40); },
                    },
                ]
                : []), [
                {
                    title: 'Kraj',
                    dataIndex: 'kraj',
                },
                {
                    title: 'Obec',
                    dataIndex: 'obec',
                },
            ]) }),
        (stranekCelkem || 0) > page && (react_1.default.createElement(ButtonWrapper, null,
            react_1.default.createElement(Button_1.default, { loading: isLoadingMore.value, onClick: handleLoadMore, name: "NactiDalsi" }, "Na\u010D\u00EDst dal\u0161\u00EDch 50")))));
};
exports.default = VysledkyVyhledavani;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;
